import { type PropsWithChildren } from 'react';
import { useImpressionRef } from '@zep/logger/react';
import { trackEvent } from '@zep/logger/tracking';
import { type BoardLandingSection } from '../constants';
type Props = PropsWithChildren<{
  section: BoardLandingSection;
  index: number;
}>;

/**
 * 섹션 하나를 감싸 "실제로 보였을 때" 1회 노출 이벤트를 쏜다(마운트 아님).
 * `once` 는 `useImpressionRef` 기본값(true)에 맡긴다 — 도달 깊이가 목적이라
 * 같은 섹션을 다시 봐도 더 쏠 이유가 없다.
 *
 * `threshold: 0` — IntersectionObserver 비율은 뷰포트가 아니라 target box
 * 기준이라, 기본값 0.5 는 섹션 높이가 뷰포트의 2배를 넘으면(모바일의
 * Samples·Features) 영영 도달 못 한다. 이 이벤트가 재는 건 "얼마나
 * 봤나"가 아니라 "도달했나"라서 0 이 맞다.
 */
export function BoardLandingSectionImpression({
  section,
  index,
  children
}: Props) {
  const ref = useImpressionRef<HTMLDivElement>(() => trackEvent('board_landing_section_view', {
    section,
    index
  }), {
    threshold: 0
  });
  return <div ref={ref} data-sentry-component="BoardLandingSectionImpression" data-sentry-source-file="BoardLandingSectionImpression.tsx">{children}</div>;
}